import RevisionSettings from './RevisionSettings';

export default RevisionSettings;



